import appComponents from '@/router/components';

const routes = [
    {
        path: '/dashboard/designs/templates/list',
        name: 'app.admin.designs.templates.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.pack_templates.index,
        },
        meta: {
            title: 'Designs Templates',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_templates']
        },
    },

    {
        path: '/dashboard/designs/templates/view/:id',
        name: 'app.admin.designs.templates.view.detail',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.pack_templates.view,
        },
        meta: {
            title: 'Designs Templates',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_templates']
        },
    },

    {
        path: '/dashboard/designs/templates/pack/:id?',
        name: 'app.admin.designs.templates.pack',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.pack_templates.form,
        },
        meta: {
            title: 'Designs Templates',
            required_auth: true,
            required_permission: true,
            permissions: ['add_design_templates', 'edit_design_templates']
        },
    },


    {
        path: '/dashboard/designs/templates/:parent_id/pages/list',
        name: 'app.admin.designs.templates.page.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.page_templates.index,
        },
        meta: {
            title: 'Designs Page Templates',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_templates']
        },
    },

    {
        path: '/dashboard/designs/templates/:parent_id/pages/edit/:id?',
        name: 'app.admin.designs.templates.page.edit',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.page_templates.form,
        },
        meta: {
            title: 'Designs Page',
            required_auth: true,
            required_permission: true,
            permissions: ['add_design_templates', 'edit_design_templates']
        },
    },

    {
        path: '/dashboard/designs/templates/:parent_id/blocks/list',
        name: 'app.admin.designs.templates.block.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.block_templates.index,
        },
        meta: {
            title: 'Designs Block Templates',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_templates']
        },
    },

    {
        path: '/dashboard/designs/templates/:parent_id/blocks/edit/:id?',
        name: 'app.admin.designs.templates.blocks.edit',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.block_templates.form,
        },
        meta: {
            title: 'Designs Block',
            required_auth: true,
            required_permission: true,
            permissions: ['add_design_templates', 'edit_design_templates']
        },
    },

    {
        path: '/dashboard/designs/categories/list',
        name: 'app.admin.designs.categories.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.categories,
        },
        meta: {
            title: 'Designs Categories',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_categories']
        },
    },

    {
        path: '/dashboard/designs/platforms/list',
        name: 'app.admin.designs.platforms.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.platforms,
        },
        meta: {
            title: 'Designs Platforms',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_platforms']
        },
    },

    {
        path: '/dashboard/designs/types/list',
        name: 'app.admin.designs.types.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.types,
        },
        meta: {
            title: 'Designs Types',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_types']
        },
    },

    {
        path: '/dashboard/designs/groups/list',
        name: 'app.admin.designs.groups.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.groups,
        },
        meta: {
            title: 'Designs Groups',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_groups']
        },
    },

    {
        path: '/dashboard/designs/dependencies/list',
        name: 'app.admin.designs.dependencies.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.dependencies,
        },
        meta: {
            title: 'Designs Dependencies',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_dependencies']
        },
    },

    {
        path: '/dashboard/designs/tags/list',
        name: 'app.admin.designs.tags.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.designs.tags,
        },
        meta: {
            title: 'Designs Tags',
            required_auth: true,
            required_permission: true,
            permissions: ['view_design_tags']
        },
    },


    {
        path: '/dashboard/license-details',
        name: 'client.license.details',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.licenseDetail,
        },
        meta: {
            title: 'License Details',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/manage-apis',
        name: 'client.manage.apis',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.manageAPIs,
        },
        meta: {
            title: 'Manage APIs',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/our-cloud',
        name: 'client.our.cloud',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.ourCloud,
        },
        meta: {
            title: 'Our Cloud',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/payment-history',
        name: 'client.payment.history',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.paymentHistory,
        },
        meta: {
            title: 'Payment Histories',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/profile',
        name: 'client.user.profile',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.profile,
        },
        meta: {
            title: 'Profile',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/share-file',
        name: 'client.share.file',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.shareFile,
        },
        meta: {
            title: 'Share File',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/workspace',
        name: 'client.workspace',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.client.workspace,
        },
        meta: {
            title: 'Workspace',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },


    {
        path: '/dashboard/payment-histories',
        name: 'client.payment.histories',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.connected_accounts.payments,
        },
        meta: {
            title: 'Payment History',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/admin/settings/download-items',
        name: 'admin.settings.download.items',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.settings.downloadItems,
        },
        meta: {
            title: 'Download Item History',
            required_auth: true,
            required_permission: true,
            permissions: ['view_download_item']
        },
    },

    {
        path: '/dashboard/admin/settings/redemptions',
        name: 'admin.settings.redemptions',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.settings.redemptions,
        },
        meta: {
            title: 'Redemptions',
            required_auth: true,
            required_permission: true,
            permissions: ['view_redemptions']
        },
    },

    {
        path: '/dashboard/admin/settings/promotional/benefits',
        name: 'admin.settings.promotional.benefits',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.settings.promotionalBenefits,
        },
        meta: {
            title: 'Benefits',
            required_auth: true,
            required_permission: true,
            permissions: ['view_promotional_benefit']
        },
    },


    {
        path: '/dashboard/admin/settings/refund-requests',
        name: 'admin.settings.refund.payments',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.settings.refunds,
        },
        meta: {
            title: 'Refund Requests',
            required_auth: true,
            required_permission: true,
            permissions: ['view_refund_requests']
        },
    },

    {
        path: '/dashboard/admin/settings/schedules',
        name: 'admin.settings.corn.schedules',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.settings.schedules,
        },
        meta: {
            title: 'Schedules',
            required_auth: true,
            required_permission: true,
            permissions: ['view_schedule_commands']
        },
    },

    {
        path: '/dashboard/refund-requests',
        name: 'refund.requests',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.refund_requests.index,
        },
        meta: {
            title: 'Refund Payments',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/payment-profile',
        name: 'payment.profile',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.connected_accounts.paymentProfile,
        },
        meta: {
            title: 'Payment Profile',
            required_auth: true,
            required_permission: true,
            permissions: ['view_client_data']
        },
    },

    {
        path: '/dashboard/redeem-code',
        name: 'redeem.code',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.connected_accounts.redeemCode,
        },
        meta: {
            title: 'Redeem Code',
            required_auth: true,
            required_permission: false,
            permissions: []
        },
    },

    {
        path: '/dashboard/free-license',
        name: 'free.license',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.promotions.freeLicense,
        },
        meta: {
            title: 'Free License',
            required_auth: true,
            required_permission: false,
            permissions: []
        },
    },

    {
        path: '/dashboard/benefits',
        name: 'benefits',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.promotions.benefits,
        },
        meta: {
            title: 'Benefits',
            required_auth: true,
            required_permission: false,
            permissions: []
        },
    },
];

export default routes;

